import fetch from '@ixigo/fetch';
import { executeApiCall } from '@/api/helper';
import { toLocalISO } from './helper';
import type {
	ConfirmRescheduleResponse,
	RescheduleFareDetailsResponse,
} from './index.types';

export const getRescheduleFareDetails = async (
	bookingId: string,
	newPickupDateTime: string,
	options?: { signal?: AbortSignal },
): Promise<RescheduleFareDetailsResponse> => {
	return executeApiCall(
		() =>
			fetch
				.post<RescheduleFareDetailsResponse>(
					'cabs/api/v1/reschedule/fareDetails',
					{
						body: JSON.stringify({
							bookingId,
							newPickupDateTime: toLocalISO(newPickupDateTime),
						}),
						headers: { 'Content-Type': 'application/json' },
						signal: options?.signal,
					},
				)
				.json(),
		`getRescheduleFareDetails:${bookingId}`,
	);
};

export const confirmReschedule = async (
	bookingId: string,
	cabSessionId: string,
	newPickupDateTime: string,
	burnOpted?: boolean,
	options?: { signal?: AbortSignal },
): Promise<ConfirmRescheduleResponse> => {
	return executeApiCall(
		() =>
			fetch
				.post<ConfirmRescheduleResponse>('cabs/api/v1/reschedule/confirm', {
					body: JSON.stringify({
						bookingId,
						cabSessionId,
						burnOpted,
						newPickupDateTime: toLocalISO(newPickupDateTime),
					}),
					headers: { 'Content-Type': 'application/json' },
					signal: options?.signal,
				})
				.json(),
		`confirmReschedule:${bookingId}`,
	);
};
